export default __webpack_public_path__ + "static/media/banner.5cc2c5bd.jpg";